<div class="modal-header">
  <h4 class="modal-title">Add Department</h4>
  <button type="button" class="btn-close" aria-label="Close" (click)="activeModal.dismiss()"></button>
</div>
<div class="modal-body">
  <form [formGroup]="departmentForm" class="mb-3">
    <div class="mb-3">
      <label class="form-label">Name</label>
      <input type="text" class="form-control" formControlName="name">
    </div>
    <div class="mb-3">
      <label class="form-label">Description</label>
      <input type="text" class="form-control" formControlName="description">
    </div>
  </form>
  @if (departments?.length) {
    <div class="table-responsive">
      <table class="table table-bordered table-sm">
        <thead>
          <tr>
            <th>Name</th>
            <th>Description</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          @for (c of departments; track c) {
            <tr>
              <td>{{ c.name }}</td>
              <td>{{ c.description }}</td>
              <td><button type="button" class="btn btn-link p-0" (click)="editDepartment(c)">Edit</button></td>
            </tr>
          }
        </tbody>
      </table>
    </div>
  }
</div>
<div class="modal-footer">
  <button type="button" class="btn btnsecondary" (click)="activeModal.dismiss()">Cancel</button>
  <button type="button" class="btn btnprimary" (click)="saveCategory()">{{ editingDepartment ? 'Update' : 'Save' }}</button>
</div>
